module.exports = __webpack_public_path__ + "open-iconic.47151e87c5a8666791a9.eot";


//////////////////
// WEBPACK FOOTER
// /home/jenkins/workspace/DOP-StaticContent-Prod-Deploy/src/assets/open-iconic-master/font/fonts/open-iconic.eot
// module id = ../../../../../src/assets/open-iconic-master/font/fonts/open-iconic.eot
// module chunks = styles